module.exports = __webpack_public_path__ + "img/atoms-logos-sweet-spot@3x.d6f7163a.png";